import Reveal from "./Reveal";

const QUOTES = [
  {
    quote: "I typed five fields, made a coffee, and the approval was waiting when I got back.",
    name: "Maya R.",
    role: "Small-business owner · Business capital",
    tint: "bg-[#007AFF]",
  },
  {
    quote: "The robot explained every fee before I signed. I checked. There were none.",
    name: "Daniel K.",
    role: "First-time borrower · Personal loan",
    tint: "bg-[#14D8A5]",
  },
  {
    quote: "Refinanced my car loan in one afternoon. My old bank took three weeks to even reply.",
    name: "Priya S.",
    role: "Auto loan · Refinance",
    tint: "bg-[#00E5FF]",
  },
];

const Testimonials = () => (
  <section data-testid="testimonials" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal className="mb-14">
        <p className="label-mono text-[#007AFF] mb-4">Field reports</p>
        <h2 className="font-display font-bold tracking-[-0.02em] leading-[1.02] text-[#0A1628] text-4xl md:text-6xl max-w-2xl">
          Humans, happy<br />with their robot.
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-10 md:gap-8">
        {QUOTES.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.08} className="h-full">
            <figure data-testid={`testimonial-${i}`} className="h-full flex flex-col border-l-2 border-[#007AFF]/25 pl-6">
              <blockquote className="font-display text-xl md:text-2xl font-medium leading-snug text-[#0A1628] flex-1">
                "{q.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full ${q.tint} text-white font-display text-sm font-bold`}>
                  {q.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-[#0A1628]">{q.name}</span>
                  <span className="label-mono text-[#52525B]">{q.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
